module.exports = __webpack_public_path__ + "static/img/phone_car_illo@3x.c7d9cbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/misc/3x/phone_car_illo@3x.png
// module id = LtQM
// module chunks = 1